import { string } from '@/shared/libs/yup';
import { HookFormField, FieldInputProps } from '@/shared/libs/hook-form';

export const jobSchema = string().label('Job Title');

export const JobField = (props: FieldInputProps) => <HookFormField.Input label="Job Title" {...props}/>;